/*
  Date de livraison estimée.
  Préparation : 48 h ouvrées, 72 h pour un maillot floqué. Transport : 7 à 10 jours ouvrés.
  Jours ouvrés du lundi au vendredi, jours fériés français exclus, calendrier de Paris.

  Emplacements repérés automatiquement (texte de préparation de la ligne d'achat, ligne sous
  « Livraison : Offerte » au panier) ; chacun reçoit « gabarit » (« %s » = la plage de dates) :
  - sur la fiche (data-fiche), « floqué » suit l'onglet de flocage choisi (Sans / Joueur / Mon nom) ;
  - ailleurs (panier), « floqué » vient de data-floque="true".
  Le texte serveur (« Livraison en 7 à 10 jours ouvrés après préparation ») reste si le script ne tourne pas.
*/
(function () {
  if (window.mfLivraison) return;

  var DELAIS = { preparation: 2, preparationFloque: 3, transportMin: 7, transportMax: 10 };
  var JOUR = 86400000;

  function aujourdhuiParis() {
    var morceaux = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date()).split('-');
    return new Date(Date.UTC(+morceaux[0], +morceaux[1] - 1, +morceaux[2]));
  }

  // Dimanche de Pâques (algorithme de Meeus), en millisecondes UTC.
  function paques(an) {
    var a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mois = Math.floor((h + l - 7 * m + 114) / 31), jour = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(an, mois - 1, jour);
  }

  var feriesParAn = {};
  function feries(an) {
    if (!feriesParAn[an]) {
      var p = paques(an);
      feriesParAn[an] = [
        Date.UTC(an, 0, 1), Date.UTC(an, 4, 1), Date.UTC(an, 4, 8), Date.UTC(an, 6, 14),
        Date.UTC(an, 7, 15), Date.UTC(an, 10, 1), Date.UTC(an, 10, 11), Date.UTC(an, 11, 25),
        p + JOUR, p + 39 * JOUR, p + 50 * JOUR
      ];
    }
    return feriesParAn[an];
  }

  function ouvre(date) {
    var j = date.getUTCDay();
    return j !== 0 && j !== 6 && feries(date.getUTCFullYear()).indexOf(date.getTime()) === -1;
  }

  function plusJoursOuvres(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d = new Date(d.getTime() + JOUR);
      if (ouvre(d)) n--;
    }
    return d;
  }

  function plage(floque) {
    var depart = plusJoursOuvres(aujourdhuiParis(), floque ? DELAIS.preparationFloque : DELAIS.preparation);
    return [plusJoursOuvres(depart, DELAIS.transportMin), plusJoursOuvres(depart, DELAIS.transportMax)];
  }

  function langue() {
    return (document.documentElement.lang || 'fr').toLowerCase();
  }

  /* Format « jour-semaine jour mois » dans les trois langues :
     fr « lun. 16 – jeu. 19 nov. », en « Mon 16 – Thu 19 Nov », es « lun 16 – jue 19 nov ».
     - en → en-GB : en-US écrit « 16 Mon » sans le mois et « Thu, Nov 19 » avec.
     - Virgules retirées : en-GB et es en mettent une seulement quand le mois est présent. */
  function texte(debut, fin) {
    var memeMois = debut.getUTCMonth() === fin.getUTCMonth();
    var lg = langue().slice(0, 2) === 'en' ? 'en-GB' : langue();
    var court = new Intl.DateTimeFormat(lg, { timeZone: 'UTC', weekday: 'short', day: 'numeric' });
    var long = new Intl.DateTimeFormat(lg, { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
    return ((memeMois ? court : long).format(debut) + ' – ' + long.format(fin)).replace(/,/g, '');
  }

  function flocageChoisi() {
    var onglet = document.querySelector('.mflo__onglet[aria-selected="true"]');
    return !!onglet && onglet.dataset.etat !== 'sans';
  }

  var GABARITS = { fr: 'Livraison estimée : %s', en: 'Estimated delivery: %s', es: 'Entrega estimada: %s' };
  function gabaritParDefaut() {
    return GABARITS[langue().slice(0, 2)] || GABARITS.fr;
  }

  // Repère les emplacements : texte de préparation de la ligne d'achat (fiche), et une ligne
  // ajoutée sous « Livraison : Offerte » dans le panier.
  function reperer() {
    var statuts = document.querySelectorAll('.mf-purchase-status');
    for (var i = 0; i < statuts.length; i++) {
      var item = statuts[i].querySelector('.mf-purchase-status__item');
      var texte = item && item.querySelector('span:last-child');
      if (texte && !texte.hasAttribute('data-mf-estimation')) {
        texte.setAttribute('data-mf-estimation', '');
        texte.setAttribute('data-fiche', '');
        texte.setAttribute('data-gabarit', gabaritParDefaut());
      }
    }
    var livraisons = document.querySelectorAll('.mf-panier__ligne--douce');
    for (var j = 0; j < livraisons.length; j++) {
      var ligne = livraisons[j];
      var suivant = ligne.nextElementSibling;
      var p = suivant && suivant.classList.contains('mf-panier__estimation') ? suivant : null;
      if (!p) {
        p = document.createElement('p');
        p.className = 'mf-panier__estimation';
        p.setAttribute('data-mf-estimation', '');
        p.setAttribute('data-gabarit', gabaritParDefaut());
        ligne.parentNode.insertBefore(p, ligne.nextSibling);
      }
      var floque = !!document.querySelector('.cart-item:not(.mf-perso) .mf-panier__flocage b');
      p.setAttribute('data-floque', floque ? 'true' : 'false');
    }
  }

  function mettreAJour() {
    reperer();
    var elements = document.querySelectorAll('[data-mf-estimation]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var gabarit = el.getAttribute('data-gabarit');
      if (!gabarit || gabarit.indexOf('%s') === -1) continue;
      var floque = el.hasAttribute('data-fiche') ? flocageChoisi() : el.getAttribute('data-floque') === 'true';
      var dates = plage(floque);
      var nouveau = gabarit.replace('%s', texte(dates[0], dates[1]));
      if (el.textContent !== nouveau) el.textContent = nouveau;
    }
  }

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(mettreAJour, 60);
  }

  window.mfLivraison = { plage: plage, mettreAJour: mettreAJour };

  function demarrer() {
    mettreAJour();
    // Le tiroir panier et la ligne d'achat sont redessinés par le thème : on repasse après chaque rendu.
    new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true });
    // Onglets de flocage : changement d'onglet = changement d'attribut, pas de nœud ajouté.
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.mflo__onglet')) planifier(); }, true);
    document.addEventListener('keyup', function (e) { if (e.target.closest && e.target.closest('.mflo__onglet')) planifier(); }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
